import { IconProductDateTime16, IconProduct3DTour16, IconMediaVideo16 } from '@cian/ui-kit-design-tokens/icons';
import { ReactNode, useMemo } from 'react';
import { FeatureLabels } from '../../components/FeatureLabels';
import { useGallery } from '../../hooks';

const assetMap: Record<string, ReactNode> = {
  has3dTour: <IconProduct3DTour16 color={'icon-inverted-default'} data-name="3D-tour-icon" />,
  hasFlatTourBooking: <IconProductDateTime16 color={'icon-inverted-default'} />,
  hasVideo: <IconMediaVideo16 color={'icon-inverted-default'} />,
};

export function FeatureLabelsContainer() {
  const { badges } = useGallery();

  const labels = useMemo(
    () => (badges?.length ? badges.map(({ type, text }) => ({ icon: assetMap[type], tooltip: text })) : null),
    [badges],
  );

  if (!labels) {
    return null;
  }

  return <FeatureLabels items={labels} />;
}
